import React, { Component } from 'react'

import "./Toolbar.css";


class ToolbarHome extends Component {




    render() {
        return (
            <div className="toolBar header_buttons">

            </div>
        )
    }
}

export default ToolbarHome

